import {Vector as VectorSource} from "ol/source";
import {Vector as VectorLayer} from "ol/layer";
import {Polygon} from "ol/geom";
import {Feature} from "ol";
import { SceneCoordinate } from '../projections';
import { Fill, Stroke, Style } from "ol/style";

const mapBoundsStyle = new Style({
  fill: new Fill({
    color: 'rgba(51, 153, 204, 0.1)'
  }),
  stroke: new Stroke({
    color: 'rgba(0, 0, 0, 0.5)',
    width: 2
  }),
});

export const boundsToMapLayer = (boundingBox) => {
  // Generate polygon layer from bounding box, based on scene coordinates
  let {min, max} = boundingBox;

  const polygonPoints = [
    new SceneCoordinate([min.x, min.y, 0]).toAerial(),
    new SceneCoordinate([min.x, max.y, 0]).toAerial(),
    new SceneCoordinate([max.x, max.y, 0]).toAerial(),
    new SceneCoordinate([max.x, min.y, 0]).toAerial(),
    new SceneCoordinate([min.x, min.y, 0]).toAerial()
  ];

  // Creating the minimap mesh layer
  let vectorsource = new VectorSource({
    wrapX: false
  });

  let geometry = new Polygon([polygonPoints], "XY");
  let feature = new Feature(geometry);
  vectorsource.addFeature(feature);

  let layer = new VectorLayer({
    source: vectorsource,
    style: mapBoundsStyle
  });

  layer.setZIndex(1);

  return layer;
};
